module.exports = __webpack_public_path__ + "static/media/kgp-slide-6.30b7e7a4.jpg";